import { Grid } from "@mui/material";
import { currencyRound } from "../../util/DoubleUtil";
import { dateTimeFormat } from "../../util/DateUtil";

const PixTransacaoView = ({ pixTransacao }) => {
  return (
    <Grid container spacing={3}>
      <Grid size={12} sx={{ fontWeight: "bold", fontSize: 20 }}>
        Pix Transação
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Código: </span>
        {pixTransacao?.codigo}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Tipo: </span>
        {pixTransacao?.tipo}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Valor: </span>
        {currencyRound(pixTransacao?.valor)}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Segundos Expiração: </span>
        {pixTransacao?.segundosExpiracao}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cliente Descrição: </span>
        {pixTransacao?.clienteDescricao}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cliente CPF/CNPJ: </span>
        {pixTransacao?.clienteCPFCNPJ}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Cliente Nome: </span>
        {pixTransacao?.clienteNome}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Retorno: </span>
        {pixTransacao?.retorno}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Detalhes Erro: </span>
        {pixTransacao?.detalhesErro}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Identificador: </span>
        {pixTransacao?.identificador}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>QrCodeTexto: </span>
        {pixTransacao?.qrCodeTexto}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>
          <img
            style={{ height: "100px", width: "100px" }}
            alt=""
            src={pixTransacao?.qrCodeImagem}
          />{" "}
        </span>
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Data Pagamento: </span>
        {dateTimeFormat(pixTransacao?.dataPagamento)}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Valor Pago: </span>
        {currencyRound(pixTransacao?.valorPago)}
      </Grid>
      <Grid>
        <span style={{ fontWeight: "bold" }}>Quitado: </span>
        {pixTransacao?.quitado ? "Sim" : "Não"}
      </Grid>
    </Grid>
  );
};

export default PixTransacaoView;
